import { LoggerBus } from '@app/utils/logger-bus';
import { getStorageData, setStorageData } from "@/utils/storage";

const loggerFormat = 'app::store::system';

const STORAGE_SYSTEM_KEY = "system";

const companyStore = {
  namespaced: true,
  state: {
    revision: null,
  },
  getters: {
    revision(state) {
      return state.revision;
    }
  },
  mutations: {
    setRevision(state, payload) {
      let system = getStorageData(STORAGE_SYSTEM_KEY);
      LoggerBus.$log.debug(`${loggerFormat}::mutations::setRevision`, system, payload);

      if (!system) {
        system = {};
      }

      if (system.revision === payload.revision) {
        LoggerBus.$log.debug(`${loggerFormat}::mutations::setRevision`, "new revision set", system);
        return;
      }
      
      system.revision = payload.revision;
      setStorageData(STORAGE_SYSTEM_KEY, system);
      LoggerBus.$log.debug(`${loggerFormat}::mutations::setRevision`, "new revision set", system);
    },
  },
  actions: {
    async setRevision({ commit },) {
      const revision = process.env.VUE_APP_REVISION;
      LoggerBus.$log.debug(`${loggerFormat}::actions::setRevision`, revision);
      commit('setRevision', {revision});
    }
  }
};

export default companyStore;
